import React from "react";
import {Alert, AlertTitle} from "@mui/material";
import {useTranslation} from "react-i18next";

type StatusParams = {
    status: string
    text?:string
}

const Status: React.FC<StatusParams> = ({status, text= ""}) => {
    const {t} = useTranslation('common');
    return (<>
        {
            {
                "dormant": <Alert severity={"info"}>Der Antrag ist erstellt und noch nicht ausgefüllt.</Alert>,
                "in-review": <Alert severity={"info"}>Der Antrag ist ausgefüllt und zur Überprüfung beim Förderer.</Alert>,
                "revising": <Alert severity={"warning"}>Du hast einen Hinweis geschickt. Dein neuer Vertriebspartner muss diesen Hinweis erst lesen und den Antrag erneut abschließen.</Alert>,
                "in-second-review": <Alert severity={"info"}>Du hast den Hinweis gelesen. Der Antrag ist nun zurück bei Deinem Förderer zur Überprüfung.</Alert>,
                "released": <Alert severity={"info"}>Der Förderer hat den Antrag als Fehlerfrei zur Überprüfung an proWIN gesendet.</Alert>,
                "pending": <Alert severity={"info"}>Der Antrag wird von der Kundenlage bei proWIN geprüft.</Alert>,
                "inquiring": <Alert severity={"warning"}>proWIN hat einen Fehler festgestellt und den Antrag zum Antragssteller geschickt.</Alert>,
                "in-sync": <Alert severity={"info"}>Der Antrag wurde von Web an PW-Central übertragen und wartet dort auf Bearbeitung.</Alert>,
                "declined": <Alert severity={"error"}>{text ? <><AlertTitle><strong>Der Antrag wurde von proWIN abgelehnt.</strong></AlertTitle>{t(text)}</> : <>{t(text)}</>}</Alert>,
                "aborted": <Alert severity={"error"}>Der Antrag wurde von proWIN abgebrochen.</Alert>,
                "uninterested": <Alert severity={"error"}>Der Antrag wurde vom Antragsteller abgebrochen.</Alert>,
                "expired": <Alert severity={"error"}>Der Antrag wurde vom Antragsteller nicht ausgefüllt und ist abgelaufen.</Alert>,
                "successful": <Alert severity={"success"}>Der Antrag wurde akzeptiert.</Alert>,
            }[status]
        }
    </>);
}

export default Status;